import { encode } from 'base-64';
import { contains } from './nodash';

const encodeGid = (gid) => {
  return contains('gid://', gid) ? encode(gid) : gid;
};

export default encodeGid;
